import { siteInfo, downloadSteps } from '@/mocks/home';

export default function DownloadGuide() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
            三步快速下载
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            简单三步，立即开启精彩体验
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            无需复杂操作，只需简单三步即可完成下载安装，马上加入全球500万用户的行列
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          <div className="hidden md:block absolute top-12 left-[calc(16.67%+40px)] right-[calc(16.67%+40px)] h-0.5 bg-background-200">
            <div className="absolute top-1/2 left-1/2 -translate-y-1/2 w-3 h-3 bg-accent-500 rounded-full"></div>
          </div>

          {downloadSteps.map((step) => (
            <div key={step.step} className="relative text-center group">
              <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center bg-accent-500 text-background-50 rounded-2xl text-xl font-bold shadow-lg shadow-accent-500/20">
                {step.step}
              </div>
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center bg-background-50 rounded-xl border border-background-200/70 group-hover:border-accent-300 transition-colors">
                <i className={`${step.icon} text-accent-500 text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-3">
                {step.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed max-w-xs mx-auto">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <div className="inline-flex flex-col sm:flex-row items-center gap-4">
            <a
              href={siteInfo.downloadLinks.ios}
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-900 text-background-50 rounded-full text-sm font-medium whitespace-nowrap hover:bg-foreground-800 transition-colors cursor-pointer"
            >
              <i className="ri-apple-fill"></i>
              iOS 版本下载
            </a>
            <a
              href={siteInfo.downloadLinks.android}
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-android-fill"></i>
              Android 版本下载
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}